import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/** Acceptance state of the current user, as returned by the Legacy backend. */
export interface TermsOfUseAcceptance {
  language: string;
  hasUserAccepted: boolean;
  latestPrivacyPolicy?: { content: string };
}

/**
 * Terms of Use / Privacy Policy endpoints of the Legacy backend (MasterData service), used unchanged:
 * same requests as the Legacy `PrivacyPolicyService`, so an acceptance in either application counts for both.
 * MasterData expects the Okta access token only (no internal token), see `allowedDomains` / `excludedDomains`.
 */
@Injectable({ providedIn: 'root' })
export class TermsOfUseApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.masterDataServiceUrl}/PrivacyPolicy`;

  getAcceptance(language: string): Observable<TermsOfUseAcceptance> {
    return this.http.get<TermsOfUseAcceptance>(`${this.baseUrl}/forUser/language/${encodeURIComponent(language)}`);
  }

  /** The backend binds the language from a form body with an empty key (`=<language>`). */
  accept(language: string): Observable<unknown> {
    const body = new HttpParams().set('', language).toString();
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(`${this.baseUrl}/acceptPolicy`, body, { headers });
  }
}
